import type { APIController, AuthenticateData } from '../../../utils/api.types';
import type { DemoConfig } from 'config/demo.config';
import { DemoClient } from 'controllers/api/demoAPI/DemoClient';
import { type Balance, type PlayResponse } from 'stake-engine';

export class DemoAPI implements APIController {
    private debug = false;
    private client: DemoClient;

    constructor(demo: DemoConfig) {
        this.client = new DemoClient(demo);
    }

    async connect(debug?: boolean): Promise<AuthenticateData> {
        if (debug) {
            this.debug = debug;
        }

        const response = await this.client.Authenticate();

        if (this.debug) {
            console.log('🕸️ API Authenticated:', response);
        }

        return response;
    }

    async spin(amount: number, mode: string = 'BASE'): Promise<PlayResponse | null> {
        if (!amount) {
            console.error('Bet amount is not set');
            return null;
        }

        console.log(`🧟 demo spin`, amount, mode);

        try {
            const response = await this.client.Play({
                amount,
                mode,
            });

            if (this.debug) {
                console.log('🕸️ API play:', response, response.round.payout);
            }

            return response;
        } catch (error: unknown) {
            if (error instanceof Error) {
                console.error(error.message);

                if (
                    error.message ===
                    'A round is already active, please call EndRound() before starting a new round'
                ) {
                    try {
                        await this.endRound();
                        return await this.spin(amount, mode);
                    } catch (error) {
                        console.error('Failed to end existing round:', error);
                    }
                }
            }

            return null;
        }
    }

    async endRound() {
        const response = await this.client.EndRound();

        if (this.debug) {
            console.log('🕸️ API endRound:', response);
        }

        return response;
    }

    async event(event: string) {
        const response = await this.client.Event(event);

        if (this.debug) {
            console.log('🕸️ API event:', response);
        }

        return response;
    }

    async balance(): Promise<Balance> {
        const { balance } = await this.client.Balance();

        if (this.debug) {
            console.log('🕸️ API balance:', balance);
        }

        return balance;
    }

    /*
      Params:
        decimals: Forces a certain number of decimals, otherwise defaults to a reasonable value based on currency.
        removeSymbol: Removes the currency symbol from the string EG CAD$1.99 -> 1.99
        trimDecimalForIntegers: Any number that is a whole number will not display the decimal points. This may help when displaying bet levels. EG 2.00 -> 2
    */
    // DisplayAmount(balance, {
    //     removeSymbol: true,
    //     decimals: 2,
    //     wholeNumberDecimals: true,
    // });
}

// 400 – Client Errors
// Status Code	Description
// ERR_VAL	Invalid Request
// ERR_IPB	Insufficient Player Balance
// ERR_IS	Invalid Session Token / Session Timeout
// ERR_ATE	Failed User Authentication / Token Expired
// ERR_GLE	Gambling Limits Exceeded
// ERR_LOC	Invalid Player Location

// 500 – Server Errors
// Status Code	Description
// ERR_GEN	General Server Error
// ERR_MAINTENANCE	RGS Under Planned Maintenance
